import Vue from 'vue';

export default {
    async me() {
        return (await Vue.http.get('/api/player')).data;
    },
    async getAnonymous() {
        return (await Vue.http.get('/api/player/anonymous')).data;
    },
    async getPaymentInfo() {
        return (await Vue.http.get('/api/player/get/payinfo')).data;
    },
    async savePaymentInfo(paymentInfo) {
        return (await Vue.http.post('/api/player/save/payinfo', paymentInfo)).data;
    },
    async playerLock(password) {
        return (await Vue.http.post('/api/player/lock', { password })).data;
    },
    async getProfile() {
        return (await Vue.http.get('/api/player/get/profile')).data;
    },
    async saveProfile(profile) {
        return (await Vue.http.post('/api/player/save/profile', profile)).data;
    },
    async getPlayerState() {
        return (await Vue.http.get('/api/playerstate')).data;
    },
    async getState() {
        const { data } = await Vue.http.get('/api/player/state');
        return {
            username: data.name,
            number: data.num,
            lastLogin: data.lgnat,
            alias: data.als,
            displayName: data.dname,
            email: data.email,
            balance: data.bln,
            lang: data.lng,
            pinInfo: data.pin,
            liveChatEmail: data.lce,
            liveChatHash: data.lch,
            liveChatCode: data.lcc,
            resetPassword: data.rpwd,
            isKioskMode: data.ksk,
            isProfileFrozen: data.frzn,
            skin: data.skin,
            phoneNumber: data.phn,
            branchParameters: data.br,
            lastAccess: data.lac,
            lastAccessPeriodMs: data.lacms,
            nextBonusPinActivationTime: data.pinat,
            haveWithdrawPins: data.wthpins,
            balancesCount: data.blc,
            activeJackpots: data.ajck,
            lastWonJackpot: data.lwjck,
            winningJackpot: data.wjck,
            notReadMessages: data.umsg,
            bonuses: data.bns,
            activeSessions: data.ses,
            jackpots: data.jck
        };
    },

    // delete after all sites will be migrated to bulmasite
    checkProfileCompleted(profile, fieldsSettings) {
        return (
            (profile &&
                fieldsSettings &&
                fieldsSettings.length &&
                (profile.alias || !this.isFieldRequired(fieldsSettings, 'alias')) &&
                (profile.phoneNumber || !this.isFieldRequired(fieldsSettings, 'phoneNumber')) &&
                (profile.firstName || !this.isFieldRequired(fieldsSettings, 'firstName')) &&
                (profile.middleName || !this.isFieldRequired(fieldsSettings, 'middleName')) &&
                (profile.lastName || !this.isFieldRequired(fieldsSettings, 'lastName')) &&
                (profile.dateOfBirth || !this.isFieldRequired(fieldsSettings, 'dateOfBirth')) &&
                (profile.passport || !this.isFieldRequired(fieldsSettings, 'passport')) &&
                (profile.address || !this.isFieldRequired(fieldsSettings, 'address')) &&
                (profile.inn || !this.isFieldRequired(fieldsSettings, 'inn')) &&
                true) ||
            false
        );
    },

    anyRequiredFields(fieldsSettings) {
        var hasRequiredFields = false;
        fieldsSettings.forEach(f => (hasRequiredFields = hasRequiredFields || f.isRequired));
        return hasRequiredFields;
    },
    getProfileField(fieldsSettings, fieldName) {
        return fieldsSettings.find(f => f.name == fieldName);
    },
    isFieldEnabled(fieldsSettings, fieldName) {
        let fld = this.getProfileField(fieldsSettings, fieldName);
        return fld;
    },
    isFieldRequired(fieldsSettings, fieldName) {
        let fld = this.getProfileField(fieldsSettings, fieldName);
        return fld && fld.isRequired;
    }
};



// WEBPACK FOOTER //
// ./_common/services/player.service.js